import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['modal', 'form', 'checkbox', 'optionAction'];

  submit(e){
    e.preventDefault();
    const formElement = this.formTarget;
    formElement.submit();
  }

  action(e) {
    e.preventDefault();
    let doctorIds = []
    this.checkboxTargets.forEach(checkbox => {
        if (checkbox.checked) {
        doctorIds.push(checkbox.value)
      }
    })
    if(this.optionActionTarget.value == "destroy" && doctorIds.length > 0) {
      this.openModal();
    }
  }

  destroy(e) {
    let doctorIds = []
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.checked) {
        doctorIds.push(checkbox.value)
      }
    })

    if (doctorIds.length > 0) {
      Rails.ajax({
            url: `doctors/multi_destroy?doctor_ids=${doctorIds}`,
            type: "DELETE",
            success: (response) => {
            if (response.success) {
            location.reload()
          }
        }
      })
    }
  }

  openModal() {
    this.modalTarget.setAttribute("style", "display: block;")
  }

  closeModal() {
    this.modalTarget.setAttribute("style", "display: none;")
  }
}